import { createContext } from 'react'

const DeliveryContext = createContext()

export default DeliveryContext
